export default __webpack_public_path__ + "static/media/logo.435e9492.jpg";